var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93773 0.682726C9.78875 0.685432 9.63758 0.738361 9.49081 0.834236L0.278977 8.10674C0.0424128 8.34178 -0.12398 8.84754 0.119856 9.15969C0.363693 9.47184 0.876716 9.51361 1.17281 9.25067L9.93791 2.33443L18.703 9.25067C18.9991 9.51378 19.5229 9.47996 19.756 9.15969C19.9604 8.87865 19.9102 8.34093 19.5968 8.10674L10.385 0.834236C10.2335 0.727707 10.0869 0.68002 9.93809 0.682726H9.93773ZM4.11972 7.78121L2.66514 8.93277V15.9555V15.9553C2.66514 16.1481 2.74174 16.3331 2.8782 16.4696C3.01449 16.6058 3.19948 16.6824 3.39243 16.6826H7.99834C8.19128 16.6824 8.37628 16.6059 8.51257 16.4696C8.64903 16.3331 8.72563 16.1481 8.72563 15.9553V13.0464C8.72563 12.3624 9.25371 11.8343 9.93772 11.8343C10.6217 11.8343 11.1498 12.3624 11.1498 13.0464V15.9553C11.1498 16.1481 11.2264 16.3331 11.3629 16.4696C11.4992 16.6058 11.6841 16.6824 11.8771 16.6826H16.483C16.6759 16.6824 16.8609 16.6059 16.9972 16.4696C17.1337 16.3331 17.2103 16.1481 17.2103 15.9553V8.9326L15.7557 7.78104V15.2276H12.6042V13.0459C12.6042 11.5812 11.4023 10.3792 9.93758 10.3792C8.47286 10.3792 7.27091 11.5812 7.27091 13.0459V15.2276H4.11945V7.78104L4.11972 7.78121Z",
    fill: "#007FA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.859c67f04315e30897c59c92c8b24bfb.svg";
export { ForwardRef as ReactComponent };